import { memo, useCallback } from 'react';
import { cn } from '@divlab/divanui';

import useInfiniteWikiArticles from '@Queries/useInfiniteWikiArticles';
import WikiArticlesCatalog from '../WikiArticlesCatalog';
import styles from './DynamicCatalog.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface DynamicCatalogProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const DynamicCatalog: FC<DynamicCatalogProps> = (props) => {
  const { className, ...restProps } = props;
  const category = useInfiniteWikiArticles();

  const handleMore = useCallback(async () => {
    if (category.isFetchingNextPage || !category.hasNextPage) return;

    category.fetchNextPage();
  }, [category]);

  if (!category.isSuccess) return null;

  const { pages } = category.data;
  const lastPage = pages[pages.length - 1];

  return (
    <div {...restProps} className={cn(styles.catalog, className)}>
      <div className={styles.catalogWrapper}>
        <WikiArticlesCatalog
          className={styles.catalog}
          pages={pages}
          hasNextPage={lastPage.countLeft > 0}
          waiting={category.isFetchingNextPage}
          onMore={handleMore}
        />
      </div>
    </div>
  );
};

export default memo(DynamicCatalog);
